/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

/** Build-time flag, deliberately independent of the page URL or user agent. */
export function isTauri(): boolean {
    // oxlint-disable-next-line node/no-process-env
    return process.env.ELEMENT_TAURI === "true";
}
